import homepage from './homepage';

export default {
    homepage,
};
